function useAlert() {

    function showWarningAlert(message) {
        alert(message);
    };

    return { showWarningAlert };
}

export default useAlert